import styled from 'styled-components';

import { Button } from 'components/Input/Button';
import { IconButton } from 'components/Input/IconButton';

export const StyledConfirmationContainer = styled.div`
  z-index: calc(${({ theme }) => theme._ui.zIndexApp} + 1);
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.canvas.overlay};
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledDialog = styled.div`
  position: relative;
  background: ${({ theme }) => theme.background.default};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  margin: ${({ theme }) => theme.spacing['3Xl']};
`;

export const StyledButtons = styled.div`
  padding: ${({ theme }) => `${theme.spacing.xl} ${theme.spacing['2Xl']} ${theme.spacing['2Xl']}`};
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.md};
`;

export const StyledButton = styled(Button).attrs({
  size: 'small',
})`
  height: 40px;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: ${({ theme }) => `${theme.spacing.lg} ${theme.spacing.xl}`};
  width: 100%;
  max-width: fit-content;
`;

export const StyledCancelButton = styled(StyledButton)`
  background: ${({ theme }) => theme.background.weakTransparent};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${({ theme }) => theme.spacing.md};
`;

export const StyledIconButton = styled(IconButton).attrs({
  priority: 'tertiary',
  variant: 'inverse',
  size: 'xs',
})`
  padding: 0;
  color: ${({ theme }) => theme.icon.default};
  :hover,
  &:not(:disabled):active {
    color: ${({ theme }) => theme.icon.default};
    background: none !important; // src/components/Input/IconButton/styles.tsx will override without
  }
  svg {
    height: ${({ theme }) => theme.spacing['2Xl']};
    width: ${({ theme }) => theme.spacing['2Xl']};
  }
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.lg};
  margin: ${({ theme }) => `0 ${theme.spacing['2Xl']}`};
`;
